import { affiliationExamLine, affiliationShort } from '@/lib/legalCopy';
import { getContentLocale } from '@/lib/contentLocale';

export function ExamAffiliationNotice({
  variant = 'inline',
}: {
  variant?: 'inline' | 'banner';
}) {
  const locale = getContentLocale();
  const text = variant === 'banner' ? affiliationShort(locale) : affiliationExamLine(locale);

  if (variant === 'banner') {
    return (
      <p className="text-[10px] sm:text-[11px] text-fg-faint leading-relaxed">
        {text}
      </p>
    );
  }

  return (
    <p className="text-[10px] sm:text-xs text-fg-faint leading-relaxed mt-2">
      {text}
    </p>
  );
}
